import { useSyncExternalStore } from 'react';

/**
 * Whether a media query matches, SUBSCRIBED rather than sampled once.
 *
 * Read through `useSyncExternalStore` and not through a library hook: the value has to be right on the
 * first client render, and a hook that starts at its server default and only corrects itself when the
 * query CHANGES never corrects itself at all for someone whose viewport already matched on load.
 *
 * The server snapshot is `false` because the server cannot know, so anything gated on this starts in
 * the query's unmatched state and settles on hydration. Only for the handful of places where the answer
 * decides what is RENDERED, or what a scroll handler MEASURES — anything that merely styles says so in
 * CSS, with a `md:`/`xl:` variant.
 */
export function useMediaQuery(query: string): boolean {
	return useSyncExternalStore(
		(onChange) => {
			const list = window.matchMedia(query);
			list.addEventListener('change', onChange);
			return () => list.removeEventListener('change', onChange);
		},
		() => window.matchMedia(query).matches,
		() => false,
	);
}
